import { makeStyles } from '@material-ui/core/styles'
import { DASHBOARD, SCHEDULE_DESKTOP_COLUMN_CALENDAR } from 'constants/breakpoints'

const useStyles = makeStyles((theme) => ({
  scheduleContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    padding: `${theme.spacing(2)}px ${theme.spacing(5)}px`,
    [theme.breakpoints.down(SCHEDULE_DESKTOP_COLUMN_CALENDAR)]: {
      padding: `${theme.spacing(2)}px ${theme.spacing(2.5)}px ${theme.spacing(12)}px ${theme.spacing(2.5)}px`,
    },
  },
  scheduleHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.between(DASHBOARD, 1000)]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.down(700)]: {
      flexDirection: 'column',
    },
  },
  cells: {
    gap: '1px',
    [theme.breakpoints.down(SCHEDULE_DESKTOP_COLUMN_CALENDAR)]: {
      marginTop: theme.spacing(5),
    },
  },
  cell: {
    display: 'flex',
    flexFlow: 'column nowrap',
    padding: theme.spacing(1),
    /* boxShadow + gap is a way to make border-collapse on grid items */
    boxShadow: `0 0 0 1px ${theme.palette.text.disabled}`,
    [theme.breakpoints.down(SCHEDULE_DESKTOP_COLUMN_CALENDAR)]: {
      flex: 1,
      padding: `${theme.spacing(0)}px ${theme.spacing(0.5)}px`,
      flexDirection: 'row',
      boxShadow: 'none',
      height: 64,
    },
  },
  emptyCell: {
    flex: 1,
    padding: `${theme.spacing(0)}px ${theme.spacing(0.5)}px`,
    flexDirection: 'row',
    boxShadow: 'none',
    height: 64,
    border: `1px solid ${theme.palette.tertiary.backgroundGrey}`,
  },
  cursorPointer: {
    cursor: 'pointer',
  },
  cellDateLabel: {
    marginRight: theme.spacing(0.75),
    letterSpacing: 0.5,
    color: theme.palette.tertiary.darkGrey,
    [theme.breakpoints.down(SCHEDULE_DESKTOP_COLUMN_CALENDAR)]: {
      marginRight: 0,
    },
  },
  cellDateRow: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down(SCHEDULE_DESKTOP_COLUMN_CALENDAR)]: {
      flexDirection: 'column',
      justifyContent: 'center',
      width: 40,
    },
  },
  scheduleIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '& svg': {
      height: '1.5em',
      fill: theme.palette.primary.main,
    },
  },
  greyBackground: {
    background: theme.palette.tertiary.backgroundGrey,
  },
  visitsWrapper: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    border: `1px solid ${theme.palette.tertiary.backgroundGrey}`,
  },
  weekDay: {
    color: theme.palette.text.disabled,
  },
}))

export default useStyles
